// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAABmJLR0QA/wD/AP+gvaeTAAAANElEQVRoge3WwQ0AIAzEsCv77wxLIFoke4I8kwAAqSS7O+KG1R0AAADP2HgAAPiOjQcABjrSpwMHOlg7MAAAAABJRU5ErkJggg==", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TaskMenu CSS start */
.kore-chat-window .sdkMenu.menuBtn .menuIcon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 100% 100%;
  width: 21px;
  height: 21px;
  margin: -4px;
  display: block;
}

.kore-chat-window .TaskPickerContainer {
  height: 462px;
  overflow-y: auto;
}

.kore-chat-window .TaskPickerContainer .taskMenuHeader .closeSheet {
  cursor: pointer;
  background: none;
  border: none;
  outline: none;
  position: absolute;
  top: 21px;
  right: 20px;
}

.kore-chat-window .TaskPickerContainer .taskMenuHeader .taskHeading {
  line-height: 2.5;
  margin-left: 17px;
  font-size: 20px;
  font-weight: bold;
  color: #000000;
}

.kore-chat-window .TaskPickerContainer .taskMenuPicker {
  height: calc(100% - 58px);
  padding: 20px 30px;
  overflow-y: auto;
}

.kore-chat-window .TaskPickerContainer .taskMenuPicker .btnTask {
  height: 56px;
  box-shadow: 0 1px 5px 0 rgba(179, 186, 200, 0.58);
  background-color: #ffffff;
  border-radius: 10px;
  padding: 8px;
  cursor: pointer;
  margin-bottom: 10px;
}

.kore-chat-window .TaskPickerContainer .taskMenuPicker .btnTask .taskIcon {
  margin-right: 15px;
}

.kore-chat-window .TaskPickerContainer .taskMenuPicker .btnTask .taskName {
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 80%;
  position: relative;
  top: 8px;
  color: #17151d;
  padding-left: 10px;
}

.kore-chat-window .TaskPickerContainer .taskMenuPicker .btnTask .displayIcon {
  width: 100%;
}

.kore-chat-window .TaskPickerContainer .taskMenuPicker .btnTask .imageIcon {
  width: 30px;
  height: 30px;
  margin: 5px 3px;
  float: left;
}

/* TaskMenu CSS end */`, "",{"version":3,"sources":["webpack://./src/plugins/v2Plugin/templates/taskPickerTemplate/taskPickerTemplate.scss"],"names":[],"mappings":"AAAA,uBAAA;AACA;EACI,yDAAA;EACA,0BAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;AACJ;;AACA;EACI,aAAA;EACA,gBAAA;AAEJ;;AAAA;EACI,eAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AAGJ;;AADA;EACI,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAIJ;;AAFA;EACI,yBAAA;EACA,kBAAA;EACA,gBAAA;AAKJ;;AAHA;EACI,YAAA;EACA,iDAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;AAMJ;;AAJA;EACI,kBAAA;AAOJ;;AALA;EACI,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,kBAAA;EACA,QAAA;EACA,cAAA;EACA,kBAAA;AAQJ;;AANA;EACI,WAAA;AASJ;;AAPA;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;AAUJ;;AARA,qBAAA","sourcesContent":["/* TaskMenu CSS start */\n.kore-chat-window .sdkMenu.menuBtn .menuIcon {\n    background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAABmJLR0QA/wD/AP+gvaeTAAAANElEQVRoge3WwQ0AIAzEsCv77wxLIFoke4I8kwAAqSS7O+KG1R0AAADP2HgAAPiOjQcABjrSpwMHOlg7MAAAAABJRU5ErkJggg==\");\n    background-size: 100% 100%;\n    width: 21px;\n    height: 21px;\n    margin: -4px;\n    display: block;\n}\n.kore-chat-window .TaskPickerContainer {\n    height: 462px;\n    overflow-y: auto;\n}\n.kore-chat-window .TaskPickerContainer .taskMenuHeader .closeSheet {\n    cursor: pointer;\n    background: none;\n    border: none;\n    outline: none;\n    position: absolute;\n    top: 21px;\n    right: 20px;\n}\n.kore-chat-window .TaskPickerContainer .taskMenuHeader .taskHeading {\n    line-height: 2.5;\n    margin-left: 17px;\n    font-size: 20px;\n    font-weight: bold;\n    color: #000000;\n}\n.kore-chat-window .TaskPickerContainer .taskMenuPicker {\n    height: calc(100% - 58px);\n    padding: 20px 30px;\n    overflow-y: auto;\n}\n.kore-chat-window .TaskPickerContainer .taskMenuPicker .btnTask {\n    height: 56px;\n    box-shadow: 0 1px 5px 0 rgba(179, 186, 200, 0.58);\n    background-color: #ffffff;\n    border-radius: 10px;\n    padding: 8px;\n    cursor: pointer;\n    margin-bottom: 10px;\n}\n.kore-chat-window .TaskPickerContainer .taskMenuPicker .btnTask .taskIcon {\n    margin-right: 15px;\n}\n.kore-chat-window .TaskPickerContainer .taskMenuPicker .btnTask .taskName {\n    display: inline-block;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    width: 80%;\n    position: relative;\n    top: 8px;\n    color: #17151d;\n    padding-left: 10px;\n}\n.kore-chat-window .TaskPickerContainer .taskMenuPicker .btnTask .displayIcon {\n    width: 100%;\n}\n.kore-chat-window .TaskPickerContainer .taskMenuPicker .btnTask .imageIcon {\n    width: 30px;\n    height: 30px;\n    margin: 5px 3px;\n    float: left;\n}\n/* TaskMenu CSS end */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
